// extracted by mini-css-extract-plugin
export default {"root":"SearchString_root__Myyxe","root_icon":"SearchString_root_icon__ZF1ai","root_icon_clear":"SearchString_root_icon_clear__dy--4"};